import { featured } from "@/mocks/fun";
import Reveal from "@/components/base/Reveal";

export default function Featured() {
  return (
    <section id="featured" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-newspaper-line"></i> 栏目·深度吐槽
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">适合静下来细品的瓜田特辑</h2>
            <p className="mt-2 text-sm text-foreground-600 md:text-base">
              不只有段子，还有编辑部亲手整的年度盘点与生活观察，笑完还能留下一点点的若有所思。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 flex flex-col gap-7">
          {featured.map((f, i) => (
            <Reveal key={f.id}>
              <article className="group grid overflow-hidden rounded-[2rem] bg-background-50 md:grid-cols-2">
                <div className={`relative overflow-hidden ${i % 2 === 1 ? "md:order-2" : ""}`}>
                  <img
                    src={f.image}
                    alt={`${f.title}深度专题封面图`}
                    className="h-56 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-full"
                  />
                  <span className="absolute left-4 top-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1.5 text-xs font-semibold text-foreground-950">
                    <i className="ri-fire-fill"></i> {f.tag}
                  </span>
                </div>
                <div className="flex flex-col justify-center p-6 md:p-9">
                  <div className="flex items-center gap-2 text-xs font-medium text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-article-line"></i> 深度吐槽特辑
                    </span>
                    <span className="h-1 w-1 rounded-full bg-foreground-300"></span>
                    <span>预计阅读 {f.readTime}</span>
                  </div>
                  <h3 className="mt-3 font-heading text-2xl leading-snug text-foreground-950 md:text-[1.7rem]">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{f.desc}</p>
                  <ul className="mt-4 space-y-2">
                    {f.points.map((p, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-foreground-700">
                        <span className="mt-1 grid h-4 w-4 shrink-0 place-items-center rounded-full bg-secondary-200 text-secondary-900">
                          <i className="ri-arrow-right-line text-[10px]"></i>
                        </span>
                        {p}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-5 flex items-center gap-2">
                    <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800">
                      全文即将送达 <i className="ri-arrow-right-line"></i>
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500">
                      <i className="ri-chat-3-line"></i> 评论区 128 条弹幕
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}